export default "__VITE_ASSET__DPdYxf1u__"